import { Component, OnInit } from '@angular/core';

import * as $ from "jquery";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-newlayout-content',
  templateUrl: './newlayout-content.component.html',
  styleUrls: ['./newlayout-content.component.scss']
})
export class NewlayoutContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
    /*var video:any = document.getElementById("bgvideo");
    if(video) {
      video.play();
    }*/
  }

}
